import { type FC } from 'react'
import { observer } from 'mobx-react-lite'
import { type SearchTypesEnum, SearchTypesEnum as SearchTypes } from 'widgets/SearchDropdown'
import { TagElement } from 'widgets/SearchDropdown/ui/SelectedElement/TagElement/TagElement'
import { TeamElement } from 'widgets/SearchDropdown/ui/SelectedElement/TeamElement/TeamElement'
import { UserElement } from 'widgets/SearchDropdown/ui/SelectedElement/UserElement/UserElement'
import { NumbersElement } from 'widgets/SearchDropdown/ui/SelectedElement/NumbersElement/NumbersElement'
import { OutboundSourcesElement } from 'widgets/SearchDropdown/ui/SelectedElement/OutboundSourcesElement/OutboundSourcesElement'
import { TimeRangeElement } from 'widgets/SearchDropdown/ui/SelectedElement/TimeRangeElement/TimeRangeElement'
import { useBreakdownFilterContext } from '../../context/breakdownFilterContext'

type ISelectedBreakdownElementProps = {
  type: SearchTypesEnum
  parentsDropdownId?: string[]
}

export const BreakdownFilterElement: FC<ISelectedBreakdownElementProps> = observer(
  ({ type, parentsDropdownId }) => {
    const {
      activeFilterType,
      isOpen,
      removeFilterType,
      tagsStore,
      membersStore,
      inboxesStore,
      numbersStore,
      outboundSourceStore,
      timeRangeStore,
    } = useBreakdownFilterContext()

    switch (type) {
      case SearchTypes.tags:
        return (
          <TagElement
            store={tagsStore}
            activeType={activeFilterType}
            onRemove={removeFilterType}
            canShowChildDropdown={isOpen}
            parentsDropdownId={parentsDropdownId}
            dropdownProps={{ marginLeft: 68 }}
          />
        )
      case SearchTypes.teams:
        return (
          <TeamElement
            store={inboxesStore}
            activeType={activeFilterType}
            onRemove={removeFilterType}
            canShowChildDropdown={isOpen}
            parentsDropdownId={parentsDropdownId}
            dropdownProps={{ marginLeft: 78 }}
          />
        )
      case SearchTypes.members:
        return (
          <UserElement
            store={membersStore}
            activeType={activeFilterType}
            onRemove={removeFilterType}
            canShowChildDropdown={isOpen}
            parentsDropdownId={parentsDropdownId}
            dropdownProps={{ marginLeft: 96 }}
          />
        )
      case SearchTypes.numbers:
        return (
          <NumbersElement
            store={numbersStore}
            activeType={activeFilterType}
            onRemove={removeFilterType}
            canShowChildDropdown={isOpen}
            parentsDropdownId={parentsDropdownId}
            dropdownProps={{ marginLeft: 100 }}
          />
        )
      case SearchTypes.outbound_sources:
        return (
          <OutboundSourcesElement
            store={outboundSourceStore}
            activeType={activeFilterType}
            onRemove={removeFilterType}
            canShowChildDropdown={isOpen}
            parentsDropdownId={parentsDropdownId}
            dropdownProps={{ marginLeft: 96 }}
          />
        )
      case SearchTypes.time_range:
        return (
          <TimeRangeElement
            store={timeRangeStore}
            activeType={activeFilterType}
            onRemove={removeFilterType}
            canShowChildDropdown={isOpen}
            parentsDropdownId={parentsDropdownId}
            dropdownProps={{ marginLeft: 115 }}
          />
        )
      default:
        return null
    }
  }
)
